import { render, staticRenderFns } from "./Contact_page.vue?vue&type=template&id=06a9fa44&"
import script from "./Contact_page.vue?vue&type=script&lang=js&"
export * from "./Contact_page.vue?vue&type=script&lang=js&"
import style0 from "./Contact_page.vue?vue&type=style&index=0&id=06a9fa44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports